/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';
import { groupBy } from '../utlis';

import { decodeToken, getToken } from '../utils/TokenUtils';
import ModalForm from './ModalForm';
import '../css/navbar.css';
import FeatherIcon from 'feather-icons-react';
const MyNavbar = () => {
  const [screenSize, setScreenSize] = useState('large'); // Track screen size

  const navigate = useNavigate();
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const userImage = decodeToken(token, 'image');
  const userEmail = decodeToken(token, 'email');
  const userName = decodeToken(token, 'name');
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  const loginPage = decodeToken(token, 'loginPage');
  const userType = decodeToken(token, 'userType');

  const passwordExpireLeft = decodeToken(token, 'passwordExpireLeft');
  const [isNavBarOpen, setIsNavBarOpen] = useState(false);
  const [isNavBarOpen2, setIsNavBarOpen2] = useState(false);

  const [filteredLinks, setFilteredLinks] = useState(false);
  const [activeCategory, setActiveCategory] = useState();

  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch data from the server when the query changes
  useEffect(() => {
    if (query.length === 0) {
      setResults([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/search-link?query=${query}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        //  console.log(response.data);
        setResults(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [query]);

  // Toggle navbar
  const toggleNavbar = () => {
    setIsNavBarOpen(!isNavBarOpen);
  };

  // Toggle navbar
  const toggleNavbar2 = () => {
    setIsNavBarOpen2(!isNavBarOpen2);
  };

  // Close navbar when a link is clicked
  const closeNavbar = () => {
    console.log('Clicked/Closed');
    setIsNavBarOpen(false);
  };

  // Close navbar when a link is clicked
  const closeNavbar2 = () => {
    console.log('Clicked/Closed');
    setIsNavBarOpen2(false);
  };

  // Function to handle path navigation and category filtering
  const handleNavigation = (e, category, path) => {
    e.preventDefault();
    closeNavbar();

    // Filter the links based on the selected category_id
    const filteredLinks = links.filter(
      (link) => link.category_id === category.category_id
    );

    // Set the active category state
    setActiveCategory(category);
    setFilteredLinks(filteredLinks);
    // Navigate to the new path
    navigate(path);

    // Optionally, log the filtered links if needed for debugging
    // console.log(path);
    //  console.log(filteredLinks);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({
    userId: null,
    token: null,
    route: null,
  });

  const onClickSearch = (e, path, route) => {
    e.preventDefault();
    setQuery('');
    setResults([]);
    // console.log(path, route);
    if (path.includes('-modal/')) {
      setModalProps({ userId, token, route });
      setIsModalOpen(true);
    } else {
      // Navigate to the new path
      navigate(path);
    }
  };

  // console.log(token);
  // Function to open the modal with dynamic props
  const handleOpenModal = (e, route) => {
    e.preventDefault();

    setModalProps({ userId, token, route });
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [categories, setCategories] = useState([]);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const linksUrl = `${API_URL}/${ENDPOINTS.SYS}/get-categories`;

    const fetchLinks = async (url) => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        // setLinks(groupBy(response.data, 'category'));
        setCategories(response.data.categories);
        setLinks(response.data.links);

        //  console.log(response.data);
      } catch (error) {
        console.log('Error fetching links ', error, 'url: ', url);
      }
    };

    fetchLinks(linksUrl);
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${API_URL}/api/users/logout`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      //  console.log('res', response, 'token:', token);

      // Remove token from localStorage
      localStorage.removeItem('authToken');
      navigate(`/login/${loginPage}`);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Remove token from localStorage

      //  localStorage.removeItem("token");
      //  navigate("/login");
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    // Filter your links object based on the search query
    const filteredLinks = Object.entries(links)
      .map(([category, items]) => {
        return [
          category,
          items.filter((item) => item.name.toLowerCase().includes(query)),
        ];
      })
      .filter(([category, items]) => items.length > 0); // Remove empty categories
    setFilteredLinks(filteredLinks); // Assuming you're using state to store filtered links
    // setLinks
  };

  // Function to handle screen resize
  const handleResize = () => {
    if (window.innerWidth < 576) {
      setScreenSize('small'); // Extra small screens
    } else if (window.innerWidth < 1592) {
      setScreenSize('medium'); // Medium screens
    } else {
      setScreenSize('large'); // Large screens (992px and above)
    }
  };

  useEffect(() => {
    handleResize(); // Set the initial state
    window.addEventListener('resize', handleResize); // Listen to resize events
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to split links into two parts: main links and dropdown links
  const splitLinks = () => {
    if (screenSize === 'large') {
      return {
        mainLinks: categories,
        dropdownLinks: [],
      };
    }
    if (screenSize === 'medium') {
      const mainLinks = categories.slice(0, 8);
      const dropdownLinks = categories.slice(8);

      return { mainLinks, dropdownLinks };
    }
    const mainLinks = categories.slice(0, 5);
    const dropdownLinks = categories.slice(5);

    return { mainLinks, dropdownLinks };
  };

  const { mainLinks, dropdownLinks } = splitLinks();

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <div className="container-fluid">
          <img
            src={`${API_URL}/${companyLogo}`}
            width="50px"
            alt="Company Logo"
            className="rounded-circle"
          />{' '}
          &nbsp;
          <a className="navbar-brand" href="/dashboard">
            {companyName}
          </a>
          {userType === 'user' && (
            <div className="position-relative">
              <input
                type="text"
                className="form-control" // Bootstrap class for styling
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search..."
                style={{
                  width: '100%', // Ensure it matches the container width
                }}
              />
              {/* {loading && <div>Loading...</div>} */}
              {results && results.length > 0 && (
                <ul
                  className="list-group position-absolute"
                  style={{
                    margin: 0,
                    top: '100%',
                    width: '100%',
                    zIndex: 1,
                    maxHeight: '200px', // Limit height
                    overflowY: 'auto', // Add vertical scroll
                    border: '1px solid #ccc', // Add border for better visibility
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                  }}
                >
                  {results.map((item, index) => (
                    <li
                      className="list-group-item"
                      key={index}
                      onClick={(e) =>
                        onClickSearch(e, item.full_route, item.route)
                      }
                      style={{
                        padding: '8px',
                        cursor: 'pointer',
                      }}
                    >
                      <small>
                        {item.name}
                        <span className="badge bg-danger">
                          {' '}
                          {item?.description}
                        </span>
                      </small>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${isNavBarOpen ? 'show' : ''}`}
            id="navbarNav"
          >
            {' '}
            <ul className="navbar-nav">
              {mainLinks &&
                mainLinks.map((link, index) => (
                  <li className={`nav-item `} key={index}>
                    <Link
                      className={`nav-link ${activeCategory?.category_id === link.category_id ? 'active' : ''}`} // Add 'active' class if category IDs match
                      href="/"
                      onClick={(e) =>
                        handleNavigation(e, link, `/${link.full_route}`)
                      } // Adjust the path accordingly
                    >
                      <FeatherIcon icon={link.category_icon} /> {link.category}
                    </Link>
                  </li>
                ))}

              {/* If there are more links on smaller screens, show them in a dropdown */}
              {dropdownLinks && dropdownLinks.length > 0 && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#a"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    More Menus
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    {dropdownLinks &&
                      dropdownLinks.map((link, index) => (
                        <li key={index}>
                          <Link
                            className="dropdown-item"
                            // href={`/${link.full_route}`}
                            //  href="/"
                            title="abc"
                            onClick={(e) =>
                              handleNavigation(e, link, `/${link.full_route}`)
                            }
                          >
                            <FeatherIcon icon={link.category_icon} />{' '}
                            {link.category}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </li>
              )}
            </ul>
            {/* User Profile Dropdown */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="/"
                  id="userDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={`${API_URL}/${userImage}`}
                    alt="User"
                    className="rounded-circle"
                    style={{ width: '30px', height: '30px' }}
                  />{' '}
                  &nbsp;&nbsp;
                  {userName}
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="userDropdown"
                >
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/"
                      onClick={(e) => handleOpenModal(e, 'change-password')}
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/logout"
                      onClick={(e) => handleLogout(e)}
                    >
                      Logout
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      // href={`#${API_URL}/${ENDPOINTS.SYS}/backup`}
                      href="/dashboard"
                      // target="_blank"
                      rel="noreferrer"
                      // onClick={(e) => handleLogout(e)}
                    >
                      Backup
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <br />
      <br />
      <br />

      {filteredLinks && (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="/dashboard">
              {activeCategory.category}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              // onClick={toggleNavbar2}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className={`collapse navbar-collapse `} id="navbarNav">
              {' '}
              <ul className="navbar-nav">
                {/* Render the "Others" category links */}
                {filteredLinks
                  .filter((link) => link.sub_category === 'Others') // Filter only the 'Others' sub_category links
                  .map((link, index) => (
                    <li className="nav-item" key={index}>
                      <Link
                        className="nav-link text-white fw-bold"
                        to={`/${link.full_route}`}
                        // onClick={closeNavbar2}
                      >
                        {/* <FeatherIcon icon={link.icon} /> */}
                        {link.name}
                      </Link>
                    </li>
                  ))}

                {/* Render dropdowns for other subcategories */}
                {filteredLinks
                  .filter(
                    (link, index, self) =>
                      self.findIndex(
                        (t) => t.sub_category === link.sub_category
                      ) === index && link.sub_category !== 'Others' // Ensure unique sub_category, excluding 'Others'
                  )
                  .map((link, index) => (
                    <li className="nav-item dropdown" key={index}>
                      <a
                        className="nav-link dropdown-toggle text-white fw-bold"
                        href="/"
                        id={`navbarDropdown-${link.sub_category}`}
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {link.sub_category}{' '}
                        {/* Dropdown title is sub_category */}
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`navbarDropdown-${link.sub_category}`}
                      >
                        {filteredLinks
                          .filter(
                            (subLink) =>
                              subLink.sub_category === link.sub_category
                          ) // Filter links by sub_category
                          .map((subLink, subIndex) => (
                            <li key={subIndex}>
                              <Link
                                className="dropdown-item"
                                to={`/${subLink.full_route}`}
                                onClick={closeNavbar}
                              >
                                {/* <FeatherIcon icon={subLink.icon} /> */}
                                {subLink.name}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </nav>
      )}

      {passwordExpireLeft !== null && passwordExpireLeft < 15 && (
        <p className="text-danger text-center fw-bold">
          <marquee>
            Your password will expire soon, it only remains {passwordExpireLeft}{' '}
            days, please{' '}
            <a href="/" onClick={(e) => handleOpenModal(e, 'change-password')}>
              change
            </a>{' '}
            it before expires.
          </marquee>
        </p>
      )}
      {/* ModalForm component */}
      {modalProps?.route && (
        <ModalForm
          userId={modalProps.userId}
          token={modalProps.token}
          route={modalProps.route}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}
    </>
  );
};

export default MyNavbar;
